//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOnlineTime, SecondToDate } from '@/utils/Date.js';
export default {
  props: ['networkInfo'],
  data: function data() {
    return {
      protoOptions: {
        static: this.$t('lang.network.staticAddress'),
        l2tp: 'L2TP',
        pptp: 'PPTP',
        dhcp: 'DHCP',
        '3g': 'PPP'
      },
      timer: null
    };
  },
  methods: {
    //计算毫秒数
    getSecond: function getSecond(msd) {
      return SecondToDate(msd);
    },
    // 计算流量
    getTraffic: function getTraffic(byte) {
      return getOnlineTime(byte);
    }
  }
};